import { isEntityLoading } from '@/Models/Entity';
import { type WorklistSortingParam } from '@/Models/GenericWorklist/WorklistParams';
import { type IWorklistStore } from './WorklistStore';
import { SortState } from '@dedalusdiit/dob-components';

export interface IWorklistSortStore {
    currentWorklistSort: WorklistSortingParam[] | undefined;
    isSortingDisabled: boolean;
    currentSortState: SortState[];
}

export default class WorklistSortStore implements IWorklistSortStore {
    private readonly worklistStore: IWorklistStore;

    constructor(
        worklistStore: IWorklistStore,
    ) {
        this.worklistStore = worklistStore;
    }

    get currentWorklistSort(): WorklistSortingParam[] | undefined {
        return this.worklistStore.worklist?.Params?.Sorting;
    }

    get currentSortState(): SortState[] {
        return (this.worklistStore.worklist?.Params?.Sorting ?? []).map((s) => ({
            columnKey: s.Column,
            direction: s.Desc ? 'desc' : 'asc',
            order: s.Priority,
        }));
    }

    get isSortingDisabled(): boolean {
        return isEntityLoading(this.worklistStore.results);
    }
}
